import React from "react";

import { DragDropContext } from "react-beautiful-dnd";

import { Item } from "./types";
import CategoryBox from "./Category-Box";
import doDrag from "./do-drag";

interface PropsInterface<T extends string = string> {
  categories: T[];
  items: Item<T>[];
  valueCategoryMap: { [value: string]: string };
  onChange: (item: string, category: T | null) => any;
  categoryClassName?: string;
  categoryLabels?: { [category: string]: string };
  orientation?: "vertical" | "horizontal";
}

function CategoriesDragDrop<T extends string = string>({
  categories,
  items,
  valueCategoryMap,
  onChange,
  categoryClassName,
  categoryLabels,
  orientation = "vertical",
}: PropsInterface<T>) {
  if (orientation === "vertical") {
    return (
      <DragDropContext onDragEnd={(p) => doDrag(p, items, onChange)}>
        {categories.map((category) => (
          <div
            key={category as string}
            className="m-1 border-b last:border-b-0"
          >
            <CategoryBox
              label={(categoryLabels || {})[category] || category}
              category={category}
              items={items}
              catItems={Object.keys(valueCategoryMap).filter(
                (v) => valueCategoryMap[v] === category
              )}
              categoryClassName={categoryClassName}
            />
          </div>
        ))}
      </DragDropContext>
    );
  } else {
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
        <DragDropContext onDragEnd={(p) => doDrag(p, items, onChange)}>
          {categories.map((category) => (
            <div
              key={category}
              className="m-2 py-4 px-3 shadow overflow-auto max-w-7xl"
            >
              <CategoryBox
                key={category}
                label={(categoryLabels || {})[category] || category}
                category={category}
                items={items}
                catItems={Object.keys(valueCategoryMap).filter(
                  (v) => valueCategoryMap[v] === category
                )}
                categoryClassName={categoryClassName}
              />
            </div>
          ))}
        </DragDropContext>
      </div>
    );
  }
}

export default CategoriesDragDrop;
